import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonButton, IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { downloadOutline } from 'ionicons/icons';
import { AppVersionFacade } from '@infra-ui/facades/app-version.facade';

@Component({
  selector: 'app-version-block-modal',
  templateUrl: './app-version-block-modal.component.html',
  styleUrls: ['./app-version-block-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, IonButton, IonIcon],
})
export class AppVersionBlockModalComponent {
  @Input() currentVersion = '';
  @Input() minSupportedVersion: string | null = null;

  constructor(private appVersionFacade: AppVersionFacade) {
    addIcons({ downloadOutline });
  }

  onUpdate(): void {
    void this.appVersionFacade.onUpdateTapped();
  }
}
